/**
 * Prose.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readString } from '@/domain/json'
import { DEFAULT_TEXT_SETTING, readTextSetting } from '@/domain/prose'
import { type TextSection } from '@/domain/section'
import TextBlock from '@/sections/text/TextBlock.vue'
import TextInspector from '@/sections/text/TextInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const textSection: SectionDefinition<'text', TextSection> = {
  kind: 'text',
  band: 'content',

  icon: ['M3 4h10', 'M3 7h10', 'M3 10h10', 'M3 13h5'],

  create: (id, title) => ({
    id,
    kind: 'text',
    title,
    html: '',
    ...DEFAULT_TEXT_SETTING,
    textStyleId: '',
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'text',
    title,
    html: readString(stored, 'html'),
    // Every setting read on its own, so a block stored before one existed reads as it was drawn.
    ...readTextSetting(stored),
    textStyleId: readString(stored, 'textStyleId'),
  }),

  block: TextBlock,
  inspector: TextInspector,
}
